export default __webpack_public_path__ + "static/media/gen-int-es.6bdbe8bc.png";